// import React from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";


// function Packages() {
//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />
         
      
    
//     </div>
//   );
// }

// export default Packages;




import React, { useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TopNavbar from '../Navbar/TopNavbar';
import SecondNav from '../Navbar/SecondNav';
import { motion } from 'framer-motion';
import Footer from './Footer';
import ChatPopup from './ChatPopup';

const packages = [
  {
    title: 'Essential Shield',
    image: 'https://cdn.pixabay.com/photo/2023/03/26/10/47/car-7878056_1280.jpg',
    description: 'Ideal for daily-use cars. Includes ceramic coating with 1-year warranty.',
    features: ['Paint Surface Protection', 'Basic Interior Detailing', 'Water Repellency'],
    duration: '1 Day',
  },
  {
    title: 'Advanced Armour',
    image: 'https://cdn.pixabay.com/photo/2016/03/11/02/08/speedometer-1249610_1280.jpg',
    description: 'Best for enthusiasts seeking enhanced protection.',
    features: ['Full-body Ceramic Coating', 'Glass & Alloy Coating', '3-Year Warranty'],
    duration: '2 Days',
  },
  {
    title: 'Ultimate Defence (PPF Combo)',
    image: 'https://media.istockphoto.com/id/170450723/photo/a-silver-sports-car-on-black-tile-floor.jpg?s=612x612&w=0&k=20&c=B5BRnhnYzfOf2BE4301r8S7h56GshGUMVAy8QnoKP0Y=',
    description: 'Top-tier package with self-healing PPF + ceramic coating.',
    features: ['Instant Healing PPF', 'Interior + Exterior Coating', '5-Year Warranty'],
    duration: '3–4 Days',
  },
  {
    title: 'Executive Gloss',
    image: 'https://media.istockphoto.com/id/2212496637/photo/businessman-protection-concept-with-car-icon-against-blue-background.jpg?s=612x612&w=0&k=20&c=woGSHUh1FKqzMRH9y74_yQUk59LL8K3STO-CVG-GAu8=',
    description: 'For executives who prefer showroom shine all year.',
    features: ['Premium Wax Layering', 'Chrome Polishing', 'Door Sealant Protection'],
    duration: '2 Days',
  },
  {
    title: 'Eco Clean Pack',
    image: 'https://media.istockphoto.com/id/1167559642/photo/modern-blue-coupe-sports-car-in-showroom.jpg?s=612x612&w=0&k=20&c=Tqid-aBP0oLJ4rLrnIrxabejDk74dWFEmeLeRbsFg6I=',
    description: 'Eco-friendly detailing with sustainable materials.',
    features: ['Waterless Wash', 'Biodegradable Products', 'Interior Deodorizing'],
    duration: '1 Day',
  },
  {
    title: 'Family Safety Plus',
    image: 'https://media.istockphoto.com/id/1483218073/photo/happy-young-sibling-feeling-fresh-air-by-shouting-on-car-sunroof-concept-of-childhood.jpg?s=612x612&w=0&k=20&c=lFb8yULPWd9I4R9HOhl4tVRMXcyhxf75LPdJTlZlFk8=',
    description: 'Perfect for family cars needing hygiene & protection.',
    features: ['Anti-Bacterial Interior', 'Child-Safe Materials', 'UV Protection'],
    duration: '1–2 Days',
  },
];

function Packages() {
  const scrollContainerRef = useRef(null);

  const scrollBy = (offset) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: offset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f5' }}>
      <TopNavbar />
      <SecondNav />

      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url('https://images.unsplash.com/photo-1474065581914-e24d783b0c55?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTcxfHxDYXJ8ZW58MHx8MHx8fDA%3D')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          display: 'flex',
          mt: 20,
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
            Premium Car Care Packages
          </Typography>
          <Typography variant="h6" sx={{ maxWidth: '700px', mx: 'auto' }}>
            Choose from a range of expertly designed packages to protect, enhance, and maintain your vehicle.
          </Typography>
        </motion.div>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Section Header */}
        <motion.div
          initial={{ x: '-100vw', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 50 }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 'bold',
              color: '#007BFF',
              textAlign: 'center',
              mb: 2,
              fontFamily: 'Arial, sans-serif',
            }}
          >
            PACKAGES
          </Typography>
        </motion.div>

        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            maxWidth: '800px',
            mx: 'auto',
            mb: 6,
            color: '#007BFF',
            fontSize: '20px',
          }}
        >
          Tailored Solutions for Every Car Owner
        </Typography>

        {/* Cards container with hidden scrollbar */}
        <Box
          ref={scrollContainerRef}
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 3,
            scrollSnapType: 'x mandatory',
            py: 2,
            px: 1,
            // Hide scrollbar for WebKit browsers (Chrome, Safari)
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            // Hide scrollbar for Firefox
            scrollbarWidth: 'none',
            // Hide scrollbar for IE, Edge
            msOverflowStyle: 'none',
          }}
        >
          {packages.map((pkg, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.3 }}
              style={{ scrollSnapAlign: 'start', flexShrink: 0 }}
            >
              <Paper
                elevation={6}
                sx={{
                  borderRadius: 4,
                  overflow: 'hidden',
                  width: 320,
                  height: 500,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="img"
                  src={pkg.image}
                  alt={pkg.title}
                  sx={{
                    height: 200,
                    width: '100%',
                    objectFit: 'cover',
                  }}
                />
                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000', mb: 1 }}>
                    {pkg.title}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1, color: '#555' }}>
                    {pkg.description}
                  </Typography>
                  <List dense sx={{ flexGrow: 1 }}>
                    {pkg.features.map((feature, idx) => (
                      <ListItem key={idx} sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}>
                          <CheckCircleIcon sx={{ color: '#2E9FFF', fontSize: '20px' }} />
                        </ListItemIcon>
                        <ListItemText primary={feature} primaryTypographyProps={{ fontSize: 14 }} />
                      </ListItem>
                    ))}
                  </List>
                  <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center' }}>
                    <AccessTimeIcon sx={{ mr: 1, color: '#007BFF' }} />
                    <Typography variant="subtitle2" sx={{ color: '#444' }}>
                      Duration: {pkg.duration}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </motion.div>
          ))}
        </Box>

        
       <ChatPopup/>
        
      </Container>
      <Footer/>
    </Box>
  );
}

export default Packages;
